// @flow
import React from "react";
import { localize } from "redux-i18n";
import { Button, View, SectionComponent, Checkbox, Icons } from "@components";
import {
  SUPPLIER_REFERRAL_STATUSES,
  SUPPLIER_REFERRAL_REPORT_ACTION_TYPE,
} from "@modules/reporting/constants/reports";
import { formatDate } from "@transformers/date";

type Props = $Exact<{
  data: *,
  confirmStatus: Function,
  supplierReferralStatus: string,
  referralType: string, // depending of selected referral type (new, active, closed), show diff layout
  ...PropsFromLocalize,
}>;

class ReferralAcknowledgementSection extends React.Component<Props> {
  get acceptRefuseReferralOption() {
    const { supplierReferralStatus, confirmStatus } = this.props;

    return (
      <View justifyContent="space-between">
        {!supplierReferralStatus && (
          <View>{this.props.t("SUPPLIER_REFERRAL_ACCEPT_REFUSE_DECISION_TEXT")}</View>
        )}
        <View>
          {supplierReferralStatus === "" ? (
            <View direction="row" justifyContent="end" gap={3}>
              <Button
                className="negative"
                onClick={confirmStatus(SUPPLIER_REFERRAL_STATUSES.INAPPROPRIATE_REFERRAL)}
              >
                {this.props.t("DECLINE_REFERRAL")}
              </Button>
              <Button
                className="positive"
                onClick={confirmStatus(SUPPLIER_REFERRAL_STATUSES.ACTIVE)}
              >
                {this.props.t("ACCEPT_REFERRAL")}
              </Button>
            </View>
          ) : (
            <View name="answer">
              {supplierReferralStatus === SUPPLIER_REFERRAL_STATUSES.ACTIVE ? (
                <div className="answer-banner positive d-flex">
                  {this.props.t("REFERRAL_ACCEPTED")}
                  <span className="material-icons pointer font-size-28" onClick={confirmStatus("")}>
                    edit
                  </span>
                </div>
              ) : (
                <div className="answer-banner negative d-flex">
                  {this.props.t("REFERRAL_DECLINED")}{" "}
                  <span className="material-icons pointer font-size-28" onClick={confirmStatus("")}>
                    edit
                  </span>
                </div>
              )}
            </View>
          )}
        </View>
      </View>
    );
  }

  get acknowledgeReferralOption() {
    const { supplierReferralStatus, confirmStatus } = this.props;

    return (
      <div className="d-flex">
        <div className="d-flex justify-content-between align-items-center mr-2">
          <span>{this.props.t("SUPPLIER_REFERRAL_ACKNOWLEDGE_DECISION_TEXT")}</span>
        </div>
        <Checkbox
          className="d-flex"
          id="supplier-acknowledge-referral-checkbox"
          onChange={confirmStatus(
            supplierReferralStatus === "" ? SUPPLIER_REFERRAL_STATUSES.ACTIVE : "",
          )}
          checked={supplierReferralStatus === SUPPLIER_REFERRAL_STATUSES.ACTIVE}
        />
      </div>
    );
  }

  get acknowledgedDate() {
    return (
      <div className="d-flex">
        <div className="d-flex justify-content-between align-items-center mr-2">
          <span>{this.props.t("SUPPLIER_REFERRAL_ACKNOWLEDGEMENT_DATE_TEXT")}</span>
        </div>
        <div className="text-pumpkin-orange font-weight-bold">
          {formatDate(this.props.data.dateAcknowledged)}
        </div>
      </div>
    );
  }

  render() {
    return (
      <SectionComponent
        id="referral-acknowledgement"
        title={<h5>{this.props.t("ACKNOWLEDGEMENT")}</h5>}
        wrapperClassName="flex-column"
        className="pb-0 pt-4"
        defaultBorder
      >
        {this.props.data.supplierTracking &&
          this.props.data.supplierTracking === SUPPLIER_REFERRAL_REPORT_ACTION_TYPE.ACCEPT_REFUSE &&
          this.acceptRefuseReferralOption}

        {this.props.data.supplierTracking &&
          this.props.data.supplierTracking === SUPPLIER_REFERRAL_REPORT_ACTION_TYPE.ACKNOWLEDGE &&
          this.acknowledgeReferralOption}

        {this.props.data.dateAcknowledged && this.acknowledgedDate}
      </SectionComponent>
    );
  }
}

export default localize()(ReferralAcknowledgementSection);
